import {useLocation, useMatches} from 'react-router';

import {AppLanguage} from '@/shared/lib/appLanguageSupports';
import {getLocalizedSeoLinks} from '@/shared/lib/router/getLocalizedSeoLinks';

/**
 * `canonical` and `hreflang` tags, emitted only on the `($lang)` routes.
 *
 * These cannot come from `meta()`: the `Meta` component fills its `matches`
 * array as it walks root -> leaf, so root's `meta()` is called with only the
 * root match and can see neither the leaf's id nor its params. `useMatches`
 * runs after that walk, so the leaf is there.
 */
export function useLocalizedSeoLinks(lang: AppLanguage, baseUrl: string) {
  const matches = useMatches();
  const {pathname} = useLocation();
  const leafRouteId = matches[matches.length - 1]?.id;

  return getLocalizedSeoLinks({routeId: leafRouteId, pathname, lang, baseUrl});
}
